<template>
    <div class="py-20 bg-gray-50" id="team">
        <div class="max-w-7xl mx-auto px-4">
            <h2 class="text-3xl font-bold text-center mb-16">专业团队</h2>
            <div class="grid grid-cols-3 gap-8">
                <div class="bg-white rounded-lg shadow-lg p-6">
                    <div class="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                        <img src="https://sx-official.oss-cn-shanghai.aliyuncs.com/zheng.jpeg" 
                             class="w-full h-full object-cover" alt="郑正文">
                    </div>
                    <h3 class="text-xl font-bold text-center mb-2">郑正文</h3>
                    <p class="text-gray-600 text-center mb-4">资深心理咨询师</p>
                    <p class="text-gray-500 text-center text-sm">从事心理健康相关工作近 20 年，带领心理类工作坊/讲座/沙龙超过 3000 小时，心理咨询小时数超过 2000小时，心理服务产品设计和项目管理经验丰富。</p>
                </div>
                <div class="bg-white rounded-lg shadow-lg p-6">
                    <div class="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                        <img src="https://sx-official.oss-cn-shanghai.aliyuncs.com/wang.jpeg" 
                             class="w-full h-full object-cover" alt="王鸥飏">
                    </div>
                    <h3 class="text-xl font-bold text-center mb-2">王鸥飏</h3>
                    <p class="text-gray-600 text-center mb-4">资深心理运营专家</p>
                    <p class="text-gray-500 text-center text-sm">华东师范大学心理学博士，全国心理服务顾问职业培训特聘讲师，全国生成式人工智能（AIGC）职业培训特聘讲师，十多所高校 MBA 最受欢迎讲师。</p>
                </div>
                <div class="bg-white rounded-lg shadow-lg p-6">
                    <div class="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                        <img src="https://sx-official.oss-cn-shanghai.aliyuncs.com/zhang.jpeg" 
                             class="w-full h-full object-cover" alt="张璜">
                    </div>
                    <h3 class="text-xl font-bold text-center mb-2">张璜</h3>
                    <p class="text-gray-600 text-center mb-4">资深心理顾问</p>
                    <p class="text-gray-500 text-center text-sm">国家二级心理咨询师，20年企业心理咨询经验，服务过500+企业客户</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ExpertTeam'
}
</script>